import apiClient from '../api';

export const extractTextFromPdf = (data) => apiClient.post(`/openAi/extract-text`, data);

export const generateVideoScript = (data) => apiClient.post(`/openAi/generate/script`, data);